import $ from 'jquery';
import { setAvailablePositions } from '../components/positionListing';

export default {
  init() {
    setAvailablePositions(document.querySelector('.careers-listing__city-nav-item--active [data-city-toggle]'));

    $('[data-city-toggle]').on('click', e => {
      setAvailablePositions(e.currentTarget);
    });
  }
};
